import { Icon, List } from "semantic-ui-react"
import type { OpenAPI } from "simplydo/interfaces"

import CircularProgress from "components/lib/CircularProgress"
import type { SideNavItemProps } from "components/lib/SideNav/SideNavComponent"
import type { UserMe } from "reducers/user"
import util from "utils/utils"

type ImpactSectionEntryProps = {
  user: UserMe
  idea: OpenAPI.GET<"/ideas/{id}">["response"]
  section: { id: string; name: string }
  activeItemId: string
  scrollToItem: (id: string) => void
  isEditing: boolean
}

export const createImpactSectionEntry = ({
  user,
  idea,
  section,
  activeItemId,
  scrollToItem,
  isEditing,
}: ImpactSectionEntryProps): SideNavItemProps => {
  const canEdit = util.canEditIdea(user, idea)

  return {
    key: "impactStatement",
    type: "link",
    content: section?.name,
    iconLeft: "balance scale",
    active: activeItemId === "impactStatement",
    onClick: () => scrollToItem("impactStatement"),
    tooltip:
      canEdit && isEditing && idea.submissibilityStatus?.detail?.impactStatement?.incorrectFields?.length > 0 ? (
        <div>
          <b>Feedback:</b>
          <div
            style={{
              padding: 8,
              maxHeight: 300,
              overflow: "auto",
            }}
          >
            <List bulleted>
              {idea.submissibilityStatus?.detail?.impactStatement?.incorrectFields?.map((field) => (
                <List.Item key={field.id}>{field.title}</List.Item>
              ))}
            </List>
          </div>
        </div>
      ) : null,
    rightIcon:
      canEdit &&
      isEditing &&
      idea.submissibilityStatus?.detail?.impactStatement &&
      idea.submissibilityStatus?.detail?.impactStatement?.visibleFields > 0 ? (
        <CircularProgress
          size={16}
          color={
            idea.submissibilityStatus?.detail?.impactStatement?.completedFields ===
            idea.submissibilityStatus?.detail?.impactStatement?.visibleFields
              ? "#28a745"
              : idea.submissibilityStatus?.detail?.impactStatement?.completedRequiredFields <
                  idea.submissibilityStatus?.detail?.impactStatement?.requiredFields
                ? "#dc3545"
                : "#007bff"
          }
          progress={
            idea.submissibilityStatus?.detail?.impactStatement?.completedFields /
            idea.submissibilityStatus?.detail?.impactStatement?.visibleFields
          }
          strokeWidth={1.5}
          icon={
            <Icon
              name="check"
              style={{
                color:
                  idea.submissibilityStatus?.detail?.impactStatement?.completedFields ===
                  idea.submissibilityStatus?.detail?.impactStatement?.visibleFields
                    ? "#28a745"
                    : idea.submissibilityStatus?.detail?.impactStatement?.completedRequiredFields <
                        idea.submissibilityStatus?.detail?.impactStatement?.requiredFields
                      ? "#dc3545"
                      : "#007bff",
              }}
            />
          }
          iconVisible={
            idea.submissibilityStatus?.detail?.impactStatement?.completedFields ===
            idea.submissibilityStatus?.detail?.impactStatement?.visibleFields
          }
        />
      ) : undefined,
  }
}
